// src/api/apiJobVouchers.js
import transport from "../utils/axios";

export const getJobVoucher = async (jobVoucherId) => {
    const response = await transport.get(`/job-vouchers/${jobVoucherId}`);
    return response.data;
};

export const exportJobVoucherToPdf = async (jobVoucherId, data) => {
    return await transport.post(`/job-vouchers/${jobVoucherId}/export-pdf`, data, { responseType: 'blob' });
};

